import { ApiExec, ApiExecPublic, ApiExecDecrypted, downloadFile } from '@utils/ApiExec';

class EventService {
  getMyRecords = (data) => ApiExec(data, 'eventos/get-my-records', 'POST');

  getPublicEvent = (data) => ApiExecPublic(data, 'app/eventos/public-get-event', 'POST');

  getAllEvents = (data) => ApiExecPublic(data, 'app/eventos/public-get-events', 'POST');

  publicGetUser = (data) => ApiExecPublic(data, 'app/eventos/public-get-user', 'POST');

  publicGetUserEvent = (data) => ApiExecPublic(data, 'app/eventos/public-get-user-event', 'POST');

  publicSetGuestEvent = (data) => ApiExecPublic(data, 'app/eventos/public-set-guest-event', 'POST', false);

  publicRegisterGuest = (data) => ApiExecPublic(data, 'app/eventos/public-register-guest', 'POST', false);

  publicRegisterGuestSencillo = (data) =>
    ApiExecPublic(data, 'app/eventos/public-register-guest-sencillo', 'POST');

  getEventsUsers = (data) => ApiExec(data, 'eventos/get-event-users', 'POST');

  getEventsUsersInvited = (data) => ApiExec(data, 'eventos/get-event-users-invited', 'POST');

  setAttendanceUsers = (data) => ApiExec(data, 'eventos/set-attendance-users', 'POST');

  setAttendance = (data) => ApiExec(data, 'eventos/set-attendance', 'POST');

  updateAttendance = (data) => ApiExec(data, 'eventos/update-attendance', 'POST');

  setEvent = (data) => ApiExecDecrypted(data, 'eventos/set-event', 'POST', false);

  updateEvent = (data) => ApiExecDecrypted(data, 'eventos/update-event', 'POST', false);

  deleteEvent = (data) => ApiExec(data, 'eventos/delete-event', 'POST');

  getQuestions = (data) => ApiExecPublic(data, 'app/eventos/public-get-questions', 'POST');

  getConvocatorias = (data) => ApiExecPublic(data, 'app/eventos/public-get-convocatorias', 'POST');

  deleteQuestions = (data) => ApiExec(data, 'eventos/delete-questions', 'POST');

  setQuestions = (data) => ApiExec(data, 'eventos/set-questions', 'POST');

  getEventosCalendar = (data) => ApiExec(data, 'eventos/get-events-calendar', 'POST');

  getEventosList = (data) => ApiExec(data, 'eventos/get-events-list', 'POST');

  getEventosDashboard = (data) => ApiExec(data, 'eventos/get-event-dashboard', 'POST');

  getEventosDetailsAttended = (data) => ApiExec(data, 'eventos/get-events-details-attended', 'POST');

  getEventosDetailsInvited = (data) => ApiExec(data, 'eventos/get-events-details-invited', 'POST');

  exportEventosDetails = (data) =>
    downloadFile({ api: 'eventos/export-events-details', method: 'POST', data });

  setOrganizador = (data) => ApiExec(data, 'eventos/set-event-organizador', 'POST');

  setInvitado = (data) => ApiExec(data, 'eventos/set-event-invitado', 'POST');

  downloadCroquis = (data) => ApiExec(data, 'eventos/download-croquis', 'POST');

  updateImage = (data) => ApiExecPublic(data, 'app/eventos/update-imagen-eventos', 'POST', false);

  getTemplate = (data) => ApiExec(data, 'eventos/get-template', 'POST');

  setTemplate = (data) => ApiExec(data, 'eventos/set-template', 'POST');

  deleteTemplate = (data) => ApiExec(data, 'eventos/delete-template', 'POST');

  updateTemplate = (data) => ApiExec(data, 'eventos/update-template', 'POST');

  generateReconocimientos = (data) => ApiExec(data, 'eventos/get-certificados', 'POST');
}

const events = new EventService();
export default events;
